export default __webpack_public_path__ + "static/media/alpharadar-home.0fc9e808.png";